export default "__VITE_ASSET__CdN$ZDn3__"